import { render } from "./HomePageNine.vue?vue&type=template&id=e28c4b9a&scoped=true"
import script from "./HomePageNine.vue?vue&type=script&lang=js"
export * from "./HomePageNine.vue?vue&type=script&lang=js"

import "./HomePageNine.vue?vue&type=style&index=0&id=e28c4b9a&lang=scss&scoped=true"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28c4b9a"]])

export default __exports__